import EntityTypeNames from 'txp-data/lib/schema/innerSchema/EntityTypeNames';
import EntityType from 'txp-data/lib/schema/innerSchema/EntityType';

export default function getEntityTypeName(entityType: EntityType): string {
    switch (entityType) {
        case EntityType.LodgingReservation:
            return EntityTypeNames.LodgingReservation;
        case EntityType.ServiceReservation:
            return EntityTypeNames.ServiceReservation;
        default:
            return null;
    }
}
